/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationDto } from '../../models/organization-dto';

export interface OrganizationsOrganizationIdGet$Json$Params {
  organizationId: string;
}

export function organizationsOrganizationIdGet$Json(http: HttpClient, rootUrl: string, params: OrganizationsOrganizationIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
  const rb = new RequestBuilder(rootUrl, organizationsOrganizationIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationDto>;
    })
  );
}

organizationsOrganizationIdGet$Json.PATH = '/organizations/{organizationId}';
